import { Component, OnInit } from '@angular/core';
import { BackButtonService } from '../../../services/back-button.service';
import { interval } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  static readonly ONLINE_STATUS_INTERVAL = 500;

  sun = 0;
  online = true;

  constructor(public backButtonService: BackButtonService) {
  }

  sunny() {
    this.sun++;
  }

  ngOnInit(): void {
    interval(HeaderComponent.ONLINE_STATUS_INTERVAL).subscribe(() => {
      this.online = navigator.onLine;
    });
  }
}
